import React from 'react';
import { Breadcrumb } from 'antd';
import { BreadcrumbProps as BreadcrumbCopyProps } from 'antd/lib/breadcrumb';

export type BreadcrumbProps = BreadcrumbCopyProps;

const ProBreadcrumb: React.FC<BreadcrumbProps> = (props) => {
  const { children, ...resProps } = props;

  return <Breadcrumb {...resProps}>{children}</Breadcrumb>;
};

export default ProBreadcrumb;
